module.exports = __webpack_public_path__ + "static/imke-4e9fd876136546f41ce7842bd56cc2b9.gif";